import { useId } from 'react-id-generator';
import { isBlankPixel } from 'lib/GoogleAds';
import { useSelector } from 'react-redux';
import AdConfig from 'lib/AdConfig';
import { AdConfigBeforeInitialization } from 'types/AdConfig';
import State from 'types/State';
import { useDeepCompareEffect } from 'react-use';
import { createAd, destroyAd } from 'lib/GoogleAds/adManager';

export default function useAd(
  adConfig: AdConfigBeforeInitialization,
  load = true
): { elementId: string; isShown: boolean } {
  const [elementId] = useId();
  const isEmpty = useSelector<State, boolean>(
    (state) => state?.ads?.slots?.find((slot) => slot.elementId === elementId)?.isEmpty ?? false
  );
  const isShown = Boolean(!isEmpty && !isBlankPixel(elementId));

  // somehow having guard clause requires this function to have explicit return types
  useDeepCompareEffect((): (() => void) => {
    if (!load) return () => {};

    const defaultConfig = {
      elementId,
    };

    const config = new AdConfig({
      ...adConfig,
      ...defaultConfig,
    });

    createAd(config.toJSON());

    return (): void => {
      destroyAd(elementId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load, adConfig]);

  return { elementId, isShown };
}
